<ng-container *transloco="let t">
  <div class="certificate-form">
    <!-- Country selector -->
    <div class="country-picker-wrapper">
      <anihis-country-picker
        (selected)="onCountrySelected($event)"
        [showLabel]="true"
        [label]="t('Country')"
      ></anihis-country-picker>
    </div>

    <!-- Country not supported message -->
    @if (
      selectedCountryCode !== null &&
      selectedCountryCode !== SUPPORTED_COUNTRY_CODE
    ) {
      <div class="country-not-supported">
        <mat-icon>info_outline</mat-icon>
        <span>{{ t('countryNotSupportedForDocument') }}</span>
      </div>
    }

    <!-- Full form — shown only when Serbia (RS) is selected -->
    @if (selectedCountryCode === SUPPORTED_COUNTRY_CODE) {
      <!-- Animal info (readonly) -->
      @if (animalData) {
        <div class="animal-info-section">
          <div class="animal-info-row">
            <span class="animal-info-label">{{ t('animalName') }}:</span>
            <span class="animal-info-value">{{ animalData.name }}</span>
          </div>
          @if (animalData.microchip) {
            <div class="animal-info-row">
              <span class="animal-info-label">{{ t('microchip') }}:</span>
              <span class="animal-info-value">{{ animalData.microchip }}</span>
            </div>
          }
        </div>
      }

      <!-- Serial number selector -->
      <!-- Purpose selector: marking vs vaccination -->
      <div
        style="
          display: flex;
          gap: 12px;
          margin-bottom: 8px;
          align-items: center;
        "
      >
        @if (animalData?.microchip) {
          <mat-checkbox [formControl]="marking">{{
            t('marking')
          }}</mat-checkbox>
          <span style="margin-left: 8px; font-weight: 600">
            {{ t('alreadyMicrochipped', { chip: animalData?.microchip }) }}
          </span>
        } @else {
          <mat-checkbox [formControl]="marking">{{
            t('marking')
          }}</mat-checkbox>
        }
        <mat-checkbox [formControl]="vaccination">{{
          t('vaccination')
        }}</mat-checkbox>
      </div>

      <!-- Serial number selector -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('selectSerialNumber') }}</mat-label>
        <mat-select [formControl]="selectedSerialNumberControl">
          <mat-option [value]="null">—</mat-option>
          @for (sn of availableSerialNumbers; track sn.uid) {
            <mat-option [value]="sn.uid">{{ sn.number }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Vaccine serial number (auto-filled) -->
      <!-- Date issued -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('dateIssued') }}</mat-label>
        <input
          matInput
          [matDatepicker]="dateIssuedPicker"
          [formControl]="dateIssued"
        
          [min]="minDate" [max]="today"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateIssuedPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #dateIssuedPicker></mat-datepicker>
      </mat-form-field>

      <!-- Vaccine name -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('vaccineName') }}</mat-label>
        <mat-select [formControl]="vaccineName">
          <mat-option [value]="''">—</mat-option>
          <mat-option *ngFor="let v of vaccines" [value]="v.name">{{
            v.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Vaccine serial number (editable, below vaccine name) -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('vaccineSerialNumber') }}</mat-label>
        <input matInput [formControl]="vaccineSerialNumber" />
      </mat-form-field>

      <!-- Passport and microchip (only for marking, and only fields not already set) -->
      @if (marking.value) {
        @if (!animalData?.passportNumber || !animalData?.microchip) {
          <div style="display: flex; gap: 12px; align-items: flex-start">
            @if (!animalData?.passportNumber) {
              <mat-form-field
                appearance="outline"
                class="full"
                style="flex: 1 1 0; min-width: 0"
              >
                <mat-label>{{ t('passportNumber') }}</mat-label>
                <input matInput [formControl]="passportNumber" />
              </mat-form-field>
            }
            @if (!animalData?.microchip) {
              <mat-form-field
                appearance="outline"
                class="full"
                style="flex: 1 1 0; min-width: 0"
              >
                <mat-label>{{ t('microchip') }}</mat-label>
                <input matInput [formControl]="microchip" />
              </mat-form-field>
            }
          </div>
        }
      }

      @if (!bothAlreadyExist) {
        <!-- Marking and registration fee -->
        <mat-form-field appearance="outline" class="full">
          <mat-label>{{ t('markingAndRegistrationFee') }}</mat-label>
          <input
            matInput
            type="number"
            [formControl]="markingAndRegistrationFee"
            [min]="0"
          />
        </mat-form-field>
      }

      <!-- Vaccination fee -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('vaccinationFee') }}</mat-label>
        <input
          matInput
          type="number"
          [formControl]="vaccinationFee"
          [min]="0"
        />
      </mat-form-field>

      <!-- Total amount (computed) -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('totalAmount') }}</mat-label>
        <input matInput type="number" [formControl]="totalAmount" readonly />
      </mat-form-field>

      <!-- Owner JMBG -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('ownerAnimalJmbg') }}</mat-label>
        <input matInput [formControl]="ownerJmbg" />
      </mat-form-field>

      <!-- Veterinarian name -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput [formControl]="veterinarianName" />
      </mat-form-field>
    }
  </div>
</ng-container>
